import React, { useEffect } from 'react'
import Heading from '../../components/Heading'
import IconButton from '../../components/IconButton'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import SelectArticle from '../../compositions/Individualization/Progress/SelectArticle'
import UploadTemplates from '../../compositions/Individualization/Progress/UploadTemplates'
import DefineAreas from '../../compositions/Individualization/Progress/DefineAreas'
import DetermineSurchargeType from '../../compositions/Individualization/Progress/DetermineSurchargeType'
import NavButtons from '../../compositions/Individualization/Progress/NavButtons'
import { useTranslation } from 'react-i18next'
import ProgressBar from '../../compositions/Individualization/Progress/ProgressBar'
import ErrorBar from '../../compositions/Individualization/Progress/ErrorBar'
import { useNavigate, useParams } from 'react-router-dom'
import { IndividualizationContextProvider } from '../../contexts/individualizationContext'
import SetMeasurements from '../../compositions/Individualization/Progress/SetMeasurements/SetMeasurements'
import { useFetchSingle } from '../../hooks/useFetchSingle'
import { StoredIndividualization } from '../../types/Individualization'
import { ApiRoutes } from '../../services/ApiService'

const DuplicateIndividualization: React.FC = () => {
    const navigate = useNavigate()
    const { t } = useTranslation(['individualization'])
    const { id, step } = useParams<{ id: string; step?: string }>()

    const { data: individualization, fetch } =
        useFetchSingle<StoredIndividualization>(ApiRoutes.INDIVIDUALIZATIONS)

    useEffect(() => {
        fetch(id)
    }, [fetch, id])

    return (
        <div>
            <Heading level={2} classes={'zr-mt-4'}>
                {t('headings.duplicate')}
            </Heading>
            <div className={'zr-mb-4'}>
                <IconButton
                    icon={faArrowLeft}
                    color={'black'}
                    onClick={() => navigate('/individualizations')}
                >
                    {t('common.backToOverview')}
                </IconButton>
            </div>
            {individualization && (
                <IndividualizationContextProvider
                    individualization={individualization}
                    step={step}
                >
                    <ProgressBar />
                    <ErrorBar />
                    <SelectArticle />
                    <UploadTemplates />
                    <SetMeasurements />
                    <DefineAreas />
                    <DetermineSurchargeType />
                    <NavButtons method={'duplicate'} />
                </IndividualizationContextProvider>
            )}
        </div>
    )
}
export default DuplicateIndividualization
